module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"textLink":"Text me the link","phonePlaceholder":"(XXX) XXX-XXXX","downloadLinkSent":"Download link sent","downloadAttemptsExhausted":"Message limit reached, please try again tomorrow","downloadLinkError":"There was an error texting you the link, please try again later"}}')
  delete Component.options._Ctor
}
